const LAB_ID = 16;
const EXERCISE_PATH = "/Lab16/Exercise";

const EXERCISE_SELECTION_DEFAULT = "default selection";

const EXERCISE_STATES = {
  EXERCISE_SELECTION_DEFAULT,
};

const TEAMMATE_INFO = {
  0: "female_poc_teammate",
  1: "male_poc_teammate",
  2: "male_white_teammate",
  3: "female_white_teammate",
};

export { LAB_ID, EXERCISE_PATH, EXERCISE_STATES, TEAMMATE_INFO };
